<template>
  <div class="company-group-stats">
    <v-progress-linear v-if="loading" indeterminate color="primary" height="2" />

    <v-tabs v-model="tab" background-color="primary" dark>
      <v-tab v-for="item in tabDefs" :key="item.key">
        <v-icon style="margin-right: 7px">{{ item.icon }}</v-icon>
        {{ item.label }}
      </v-tab>
    </v-tabs>

    <v-tabs-items v-model="tab" :touchless="true">
      <v-tab-item>
        <div class="px-2 mt-2">
          <group-meals-meals-chart :orders="orders" />
        </div>
      </v-tab-item>
      <v-tab-item>
        <div class="px-2 mt-2">
          <group-meals-shifts-chart :orders="orders" />
        </div>
      </v-tab-item>
      <v-tab-item>
        <div class="px-2 mt-2">
          <group-meals-days-chart :orders="orders" />
        </div>
      </v-tab-item>
      <v-tab-item>
        <div class="px-2 mt-2">
          <group-meals-categories-chart :orders="orders" />
        </div>
      </v-tab-item>
    </v-tabs-items>
  </div>
</template>

<script>
import reportService from "@/services/report";
import companyService from "@/services/company";
import GroupMealsMealsChart from "@/components/statistics/group-meals/GroupMealsMealsChart.vue";
import GroupMealsShiftsChart from "@/components/statistics/group-meals/GroupMealsShiftsChart.vue";
import GroupMealsDaysChart from "@/components/statistics/group-meals/GroupMealsDaysChart.vue";
import GroupMealsCategoriesChart from "@/components/statistics/group-meals/GroupMealsCategoriesChart.vue";

export default {
  name: "CompanyGroupStats",
  components: { GroupMealsMealsChart, GroupMealsShiftsChart, GroupMealsDaysChart, GroupMealsCategoriesChart },
  props: {
    date: { type: Array, default: () => [] },
  },
  data() {
    return {
      loading: false,
      orders: [],
      branches: [], // [[id, name], ...]
      tab: 0,
    };
  },
  computed: {
    tabDefs() {
      return [
        { key: "meals", icon: "mdi-food-drumstick", label: this.$t("meal_in_meals") },
        { key: "shifts", icon: "mdi-clock-time-four-outline", label: this.$t("orders_by_shift") },
        { key: "days", icon: "mdi-calendar-range", label: this.$t("daily") },
        { key: "categories", icon: "mdi-shape", label: this.$t("groups_meal") },
      ];
    },
  },
  methods: {
    async fetchBranches() {
      const companyId = this.$store.state.company?.id;
      if (!companyId) return;
      try {
        const { data } = await companyService.getBranches({ companies: companyId });
        this.branches = Array.isArray(data) ? data : [];
      } catch {
        this.branches = [];
      }
    },
    async fetchData() {
      const companyId = this.$store.state.company?.id;
      if (!companyId || !this.date?.length) return;
      this.loading = true;
      try {
        const from = this.date[0];
        const to = this.date[1] || this.date[0];
        // Use branch IDs if available, otherwise fall back to parent company ID
        const branchIds = this.branches.map((b) => b[0]);
        const companyParam = branchIds.length ? branchIds.join(",") : companyId;
        const res = await reportService.getCompanyFoodKorisnici(companyParam, {
          date: from,
          date2: to,
        });
        this.orders = this.parseOrders(res.data?.users || []);
      } catch {
        this.orders = [];
      } finally {
        this.loading = false;
      }
    },
    // Flatten per-user/per-date/per-shift data into a flat orders array
    // compatible with GroupMeals* chart components
    parseOrders(users) {
      const result = [];
      for (const user of users) {
        const shift = user.shift || 1;
        const date = user.date || "";
        for (const order of user.orders || []) {
          const qty = Number(order.quantity) || 0;
          if (!qty) continue;
          result.push({
            meal_name: this.toLatin(order.food?.name || ""),
            quantity: qty,
            shift,
            date,
            category_name: this.toLatin(order.food?.category?.name || ""),
          });
        }
      }
      return result;
    },
  },
  watch: {
    date: { handler() { this.fetchData(); }, deep: true },
  },
  async created() {
    await this.fetchBranches();
    this.fetchData();
  },
};
</script>

<style scoped>
.company-group-stats ::v-deep .v-tabs-items,
.company-group-stats ::v-deep .v-window__container,
.company-group-stats ::v-deep .v-window-item {
  overflow: visible !important;
}
</style>
